export async function apiRequest(path, options = {}) {
  const method = options.method || "GET";
  const apiPrefix = (process.env.REACT_APP_API_PREFIX || "/api").replace(/\/$/, "");
  const normalizedPath = String(path || "").startsWith("/") ? path : `/${path}`;
  const isFormData = options.body instanceof FormData;

  const response = await fetch(`${apiPrefix}${normalizedPath}`, {
    method,
    headers: {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(options.headers || {}),
    },
    body: options.body ? (isFormData ? options.body : JSON.stringify(options.body)) : undefined,
    credentials: "include",
  });

  const contentType = response.headers.get("content-type") || "";
  const data = contentType.includes("application/json")
    ? await response.json()
    : await response.text();

  if (!response.ok) {
    throw new Error(typeof data === "string" ? data : data?.message || "Request failed");
  }

  return data;
}
